import React from 'react';
import './portfolio.scss';
import PortfolioList from '../portfolioList/PortfolioList';
import { useState } from 'react';
import { useEffect } from 'react';

import {
    featuredPortfolio,
    webPortfolio,
    mobilePortfolio,
    designPortfolio,
    contentPortfolio
} from "../../Data"


const Portfolio = () => {


    const [selected, setselected] = useState("featured")

    const [data, setData] = useState([]);

    const list = [

        {
            id: "featured",
            title: "Featured",
        },
        {
            id: "web",
            title: "Web App",
        },
        {
            id: "mobile",
            title: "Mobile App",
        },
        {
            id: "design",
            title: "Design",
        },
        {
            id: "content",
            title: "Content",
        },
    ];

    useEffect(() => {
        switch (selected) {
            case "featured":
                setData(featuredPortfolio);
                break;
            case "web":
                setData(webPortfolio);
                break;
            case "mobile":
                setData(mobilePortfolio);
                break;
            case "design":
                setData(designPortfolio);
                break;
            case "content":
                setData(contentPortfolio);
                break;
            default:
                setData(featuredPortfolio);

        }

    }, [selected])

    return (
        <div className="portfolio" id="portfolio">

            <h1>Portfolio</h1>
            <ul>
                {
                    list.map((item, index) => (

                        <PortfolioList

                            title={item.title}

                            active={selected === item.id}

                            setselected={setselected}

                            id={item.id}

                            key={index}

                        />

                    ))

                }
            </ul>

            <div className="container">

                {
                    data.map((d, index) => (

                        <a href={d.link} target="_blank" rel="noreferrer" key={index}>   <div className="item">
                            <img src={d.img} alt="google" />
                            <h3>{d.title}</h3>
                        </div>
                        </a>

                    ))
                }

            </div>
        </div>
    )
}

export default Portfolio;
